module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/db33521c211f891a365334fead160483.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_excel.svg
// module id = NtnF
// module chunks = 0